var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 692,
    viewBox: "0 0 1440 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5765_67473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 692
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 692,
    transform: "matrix(1 0 0 -1 0 692)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5765_67473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.139 152.02C665.76 127.459 695.903 117.781 720.464 130.402L1998.45 787.144C2023.01 799.766 2032.69 829.908 2020.06 854.469L1546.48 1776.03C1533.86 1800.59 1503.92 1810.37 1479.37 1797.75C1365.5 1739.27 1056.31 1580.44 840.648 1469.51C625.49 1358.84 315.161 1199.43 201.005 1140.79C176.438 1128.17 166.946 1098.13 179.569 1073.56L653.139 152.02Z",
    fill: "#BAFAC7",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.139 145.02C285.76 120.459 315.903 110.781 340.464 123.402L1618.45 780.144C1643.01 792.766 1652.69 822.908 1640.06 847.469L1166.48 1769.03C1153.86 1793.59 1123.92 1803.37 1099.37 1790.75C985.501 1732.27 676.308 1573.44 460.648 1462.51C245.49 1351.84 -64.8389 1192.43 -178.995 1133.79C-203.562 1121.17 -213.054 1091.13 -200.431 1066.56L273.139 145.02Z",
    fill: "#D9FAE1",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.4e4032b595a3e4bad96c70cb4dab75b2.svg";
export { ForwardRef as ReactComponent };